/**
 * Format a number as Turkish Lira with compact notation
 *
 * @param value - The numeric value to format
 * @returns Formatted string with TL suffix
 *
 * @example
 * formatTurkishLira(456)         // "456 TL"
 * formatTurkishLira(1118)        // "1.1K TL"
 * formatTurkishLira(118633)      // "118.6K TL"
 * formatTurkishLira(770926)      // "770.9K TL"
 * formatTurkishLira(16334446)    // "16.3M TL"
 * formatTurkishLira(1200000)     // "1.2M TL"
 */
export function formatTurkishLira(value: number): string {
  // Million format (≥1M)
  if (value >= 1_000_000) {
    return (value / 1_000_000).toFixed(1) + 'M TL'
  }

  // Thousand format (1K-999K)
  if (value >= 1_000) {
    return (value / 1_000).toFixed(1) + 'K TL'
  }

  // Normal format (<1K)
  return new Intl.NumberFormat('tr-TR').format(value) + ' TL'
}
